export const Styles = {
    errorDisplay: {
        margin: '40px 0px',
    },
};
